/**
 * i18nProvider types
 */
export var I18N_TRANSLATE = 'I18N_TRANSLATE';
export var I18N_CHANGE_LOCALE = 'I18N_CHANGE_LOCALE';
//# sourceMappingURL=types.js.map